import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import noImage from "../../images/no_image.jpg";
import wizard from "../../images/wizard.gif";
import "../../css/PostProperty.css";
import check from "../../images/check1.jpg";
import advanceValidateForm from "../validations/CustomAdvanceValidations";
import Procedures from "../common/Procedures";
import validateForm from "../validations/CustomValidations";
import PropertyDetailForm from "../forms/PropertyDetailForm";
import "../../css/AdditionalDetails.css";
import addPhoto from "../../images/addPhoto.png";
import advancedDetails from "../../images/advancedDetails.png";
import verify from "../../images/verify.png";
import returnHome from "../../images/return.png";
import AdvanceForm from "../forms/AdvanceForm";
import { AppContext } from "../../context/AppContext";
import CustomDropdown from "../common/CustomDropdown";
import TipModal from "../modals/TipModal";
import config from "../../config/config";
import { useLocation } from "react-router-dom";
import { sendWhatsappMessageApi } from "../../api/commonApi";
import { useParams } from "react-router-dom";
import { eventEmitter } from "../EventEmitter";
import ConfirmationModal from "../modals/ConfirmationModal";
import BlurModal from "../modals/BlurModal";

export default function PostProperty() {
  const { listingId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, setUser, loggedIN } = useContext(AppContext);
  const token = config.getAuthToken();
  const [apiData, setApiData] = useState([]);
  const [emitterEvent, setEmitterEvent] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showBlurModal, setShowBlurModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");
  const [dataFields, setDataFields] = useState([]);
  const [dataDescriptions, setDataDescriptions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const options = ["Broker", "Owner", "Builder", "Flatmate"];
  const mainSteps = ["details", "images", "advanced", "verify"];
  const steps = ["Basic Details", "Property Details", " Price Details"];
  const [activeStep, setActiveStep] = useState(0);
  const [activeMainStep, setActiveMainStep] = useState(0);
  const [uniqueId, setUniqueId] = useState(
    Math.floor(100000000000 + Math.random() * 900000000000).toString()
  );
  const [propertyId, setPropertyId] = useState("");
  const [errors, setErrors] = useState({});
  const [reminderErrors, setReminderErrors] = useState({});
  const [images, setImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [projectInput, setProjectInput] = useState("");
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [localityInput, setLocalityInput] = useState("");
  const [localities, setLocalities] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loadingLocalities, setLoadingLocalities] = useState(false);
  const [isTipModalOpen, setIsTipModalOpen] = useState(false);
  const cityOptions = [{ value: "1", label: "Jaipur" }];
  const typeOptions = [
    { value: "residential", label: "Residential" },
    { value: "commercial", label: "Commercial" },
  ];
  const serviceOptions = [
    { value: "rent", label: "Rent" },
    { value: "sell", label: "Sell" },
    { value: "living", label: "PG/Co-Living" },
  ];

  const handlePostPropertyClick = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      setActiveMainStep(1);
    }, 5000);
  };

 // State to hold the complete property form data across steps
  const [formData, setFormData] = useState({
    basicDetails: {
      id: "",
      profileEdit: "",
      userId: "",
      uniqueId: uniqueId,
      self: "",
      name: "",
      city_id: "1",
      email: "",
      phone: "",
      property_category: "",
      property_service: "",
    },
    propertyDetails: {
      property_type: "",
      project_id: "",
      sub_locality_id: "",
      furnish_type: "",
      locality_id: "",
      bhk: "",
      possession_status: "",
      available_from: "",
      property_age: "",
      zone_type: "",
      ownership: "",
      location_hub: "",
      other_location_hub: "",
      property_name: " ",
      plot_area: "",
      length: "",
      width: "",
      area_unit: "",
      property_condition: "",
      carpet_area: "",
      construction_status: "",
      total_floor: "",
      your_floor: "",
      number_of_meeting_rooms_input: "",
      number_of_seats_input: "",
      number_of_cabins_input: "",
      buildup_area: "",
      share_agent: "",
      amenities: "",
      amenities_furnishes: "",
      amenities_society: "",
      service_lift: "",
      passenger_lifts: "",
      private_parking: "",
      public_parking: "",
      negotiable: "",
      dg_ups_charges: "",
      tax_govt_charges: "",
      private_washroom: "",
      public_washroom: "",
      electricity_charges: "",
      entrance_width: "",
      ceiling_height: "",
      painting_charge: "",
      painting_charge_amount: "",
      facing: "",
      servent_room: "",
      parking_charge: "",
      parking_charge_amount: "",
      address: "",
      bathroom: "",
      boundary_wall: "",
      width_facing_road: "",
      corner_plot: "",
      construction_start: "",
      parking_open: "",
      parking_covered: "",
      water_charges: "",
      reminder_date: "",
      reminder_time: "",
      pg_name: "",
      pg_total_beds: "",
      pg_for: "",
      pg_suitable_for: "",
      pg_meals_available: "",
      pg_meals_offering: "",
      pg_notice_period: "",
      pg_lock_in: "",
      pg_common_area: "",
      pg_meals_speciality: "",
      meal_charge: "",
      electricity_charge: "",
      non_veg: "",
      opposite_sex: "",
      drinking_allowed: "",
      smoking_allowed: "",
      visitor_allowed: "",
      guardian_allowed: "",
      brokerage_amount: "",
      lock_period_amount: "",
      transaction_type: "",
      maintenance_charge: "",
      brokerage_charge: "",
      brokerage_negotiable: "",
      lock_period: "",
      conference_room: "",
      flooring: "",
      suitable_for: "",
      floor_no: "",
      open_sides: "",
      plot_approved: "",
      plot_authority: "",
      floor_construction: "",
      total_stairs: "",
      possession_date: "",
      balcony: "",
    },
    propertyPrice: {
      pricing: "",
      security_deposit_month: "",
      security_deposit_amount: "",
    },
    roomDetail: {},
  });

  // Delete a room detail entry by its index
  const handleInputDelete = (step, priceIndex = null) => {
    if (step === "roomDetail" && priceIndex !== null) {
      setFormData((prev) => {
        const updatedRoomDetails = { ...prev[step] };

        // Remove the entire object at `priceIndex`
        delete updatedRoomDetails[priceIndex];

        return {
          ...prev,
          [step]: updatedRoomDetails,
        };
      });

      setErrors((prev) => {
        const updatedErrors = { ...prev[step] };

        // Remove errors related to this `priceIndex`
        delete updatedErrors[priceIndex];

        return {
          ...prev,
          [step]: updatedErrors,
        };
      });

      console.log(formData);
    }
  };

  // Handle input change and update the state accordingly
  const handleInputChange = (step, field, value, priceIndex = null) => {
    if (step === "roomDetail" && priceIndex !== null) {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}), // Preserve existing data at this index
            [field]: value, // Push new field-value
          },
        },
      }));

      setErrors((prev) => ({
        ...prev,
        [step]: {
          ...(prev[step] || {}),
          [priceIndex]: {
            ...(prev[step]?.[priceIndex] || {}),
            [field]: "", // Clear error for the specific field
          },
        },
      }));

      console.log(formData);
    } else {
      setFormData((prev) => ({
        ...prev,
        [step]: {
          ...prev[step],
          [field]: value,
        },
      }));
      setErrors((prev) => ({
        ...prev,
        [field]: "", // Clear error for the field being modified
      }));

      console.log(formData);
    }
  };

  const handleActiveSteps = (index) => {
    setActiveStep(index);
  };

  // Handle moving to the next form step after validation
  const handleNextStep = (index = null) => {
    if (index < activeStep) {
      setActiveStep(index);
      return;
    } else if (index > activeStep) {
      return;
    }
    const validationErrors = validateForm(
      activeStep,
      formData,
      formData.basicDetails.property_category,
      formData.basicDetails.property_service,
      formData.basicDetails.self
    );
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setActiveStep((prev) => prev + 1);
    }
  };

  // Final submit action from advanced step with extra validations
  const handleAdvanceSubmit = async (e) => {
    e.preventDefault();
    const advanceValidationErrors = advanceValidateForm(
      formData,
      formData.basicDetails.property_category,
      formData.basicDetails.property_service,
      formData.propertyDetails.property_type,
      formData.basicDetails.self
    );
    setErrors(advanceValidationErrors);

    if (Object.keys(advanceValidationErrors).length === 0) {
      createOrUpdateProperty();
    } else {
    }
  };

  // Submit reminder form with date/time validation
  const handleSetReminderSubmit = async (e) => {
    e.preventDefault();
    const { reminder_date, reminder_time } = formData.propertyDetails;
    const newReminderErrors = {};

    if (!reminder_date) {
      newReminderErrors.reminder_date = "Please select a reminder date.";
    }

    if (!reminder_time) {
      newReminderErrors.reminder_time = "Please select a reminder time.";
    }

    if (reminder_date && reminder_time) {
      const selectedDateTime = new Date(`${reminder_date}T${reminder_time}`);
      const now = new Date();

      if (selectedDateTime < now) {
        newReminderErrors.reminder_time =
          "Reminder date and time cannot be in the past.";
      }
    }

    if (Object.keys(newReminderErrors).length > 0) {
      setReminderErrors(newReminderErrors);
      return;
    }

    // Clear errors and proceed
    setReminderErrors({});
    await createOrUpdateProperty();

    setShowConfirmModal(true);
    setMsgTitle("Reminder Set");
    setMessage(
      "Your reminder has been scheduled successfully. Our team will ensure timely follow-up."
    );
    setIcon("fa fa-check-circle-o");
    setTheme("green");
    //  alert("Reminder Set");
  };

  // Generic form submit handler (usually final step)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm(
      activeStep,
      formData,
      formData.basicDetails.property_category,
      formData.basicDetails.property_service,
      formData.basicDetails.self
    );
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length != 0) {
    } else {
      createOrUpdateProperty();
    }
  };

  const updateUser = async () => {
    try {
      const formDataNew = new FormData();

      formDataNew.append("name", formData.basicDetails.name);
      formDataNew.append("mobile", formData.basicDetails.phone);
      formDataNew.append("email", formData.basicDetails.email);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/editProfile`,
        formDataNew,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        loggedIN(token, response.data);
        // navigate('/myProfile?value=myProfile');
      } else {
        alert(response.data.message || "Failed to update profile.");
      }
    } catch (error) {
      console.error("Error updating profile:", error);

      if (error.response) {
        const { data } = error.response;

        if (data.errors) {
          // Laravel returns validation errors in 'errors' object
          let errorMessage = Object.values(data.errors).flat().join("\n");
          alert(errorMessage);
        } else {
          // General server error message
          alert(data.message || "Failed to update profile.");
        }
      } else if (error.request) {
        alert(
          "No response from server. Please check your internet connection."
        );
      } else {
        alert("An unexpected error occurred. Please try again.");
      }
    }
  };

  // Create or update property post based on listingId
  const createOrUpdateProperty = async (e) => {
    const apiName = listingId ? "updateProperty" : "postProperty";

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/${apiName}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 201) {
        handleInputChange("basicDetails", "id", response.data.id);
        handlePostPropertyClick();
        await sendWhatsappMessageApi({
          slug: "user_post_property",
          mobile: user?.data?.mobile,
          name: user?.data?.name,
          title: response.data?.title,
          location: response.data?.location,
          token: token,
          link: response.data?.link,
        });
      }
      if (response.status === 200) {
        if (listingId) {
          if (activeMainStep == 0) {
            handlePostPropertyClick();
            await sendWhatsappMessageApi({
              slug: "user_update_property",
              mobile: user?.data?.mobile,
              name: user?.data?.name,
              title: response.data?.title,
              location: response.data?.location,
              token: token,
              link: response.data?.link,
            });
          } else {
            navigate("/myProfile?value=myListings");
          }
        } else {
          setActiveMainStep(3);
        }
      } else {
        setErrors("Failed to add property. Please try again.");
      }
    } catch (error) {
      console.error("Property Add error:", error);
      setErrors("An error occurred. Please try again later.");
    }
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    uploadImages(files);
  };

  // Handle drag-over event
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    uploadImages(files);
  };

  // Handle delete image
  const handleCategory = async (imageId, value) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/imageCategory`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId, category: value }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        console.error("Category Save");
      } else {
        alert("Failed to save category!");
      }
    } catch (error) {
      console.error("Error save category:", error);
    }
  };

  // Handle delete image
  const handleDelete = async (index, imageId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/deletePropertyImage`,
        {
          method: "POST", // Use POST if DELETE is not supported
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ image_id: imageId }),
        }
      );

      const result = await response.json();
      console.log(result);

      if (result.status) {
        // Remove the deleted image from state
        setImages((prevImages) => prevImages.filter((_, i) => i !== index));
      } else {
        alert("Failed to delete image!");
      }
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  // Upload multiple property images
  const uploadImages = async (files) => {
    const formImageData = new FormData();
    files.forEach((file) => formImageData.append("images[]", file));
    formImageData.append("property_id", formData.basicDetails.id);
    formImageData.append("user_id", formData.basicDetails.userId);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/uploadPropertyImages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formImageData,
        }
      );

      const result = await response.json();

      if (result.status) {
        setImages((prevImages) => [...prevImages, ...result.data]);
      } else if (!result.status) {
        alert("something went wrong");
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  // Fetch existing property images (e.g., on edit mode)
  const getPropertyImages = async () => {
    const formImageData = new FormData();
    formImageData.append("property_id", listingId);
    formImageData.append("user_id", user?.data?.id);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/getPropertyImages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formImageData,
        }
      );

      const result = await response.json();

      if (result.status) {
        setImages(result.data);
      } else if (!result.status) {
        alert("something went wrong");
      }
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  // Check whether profile fields are complete before continuing
  const checkProfile = () => {
    let missingFields = [];

    if (!user?.data?.name) missingFields.push("name");
    if (!user?.data?.mobile) missingFields.push("mobile");
    if (!user?.data?.email) missingFields.push("email");

    handleInputChange(
      "basicDetails",
      "profileEdit",
      missingFields.length > 0 ? missingFields : null
    );
  };

  // Open a modal, e.g., for alerts, confirmations, or help
  const openVisibleModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeVisibleModal = () => {
    setIsModalOpen(false);
  };

  const openTipModal = () => {
    setIsTipModalOpen(true);
    const dataLabels = getAllDataLabels("myForm");
    const dataDescriptions = getAllDataDescriptions("myForm");
    setDataFields(dataLabels);
    setDataDescriptions(dataDescriptions);
  };

  // Function to close the Tip Modal
  const closeTipModal = () => {
    setIsTipModalOpen(false);
  };

  // Function to get all 'data-field' values from a given form
  function getAllDataLabels(formId) {
    // Select the form by its ID
    const form = document.getElementById(formId);

    // If form is found, proceed
    if (form) {
      // Get all elements within the form with a 'data-label' attribute
      const elements = form.querySelectorAll("[data-field]");

      // Map the elements to extract their 'data-label' values
      const labels = Array.from(elements).map((element) =>
        element.getAttribute("data-field")
      );

      // Return the array of data-label values
      return labels;
    } else {
      console.error("Form not found");
      return [];
    }
  }

  // Function to get all 'data-description' values from a given form
  function getAllDataDescriptions(formId) {
    // Select the form by its ID
    const form = document.getElementById(formId);

    // If form is found, proceed
    if (form) {
      // Get all elements within the form with a 'data-label' attribute
      const description = form.querySelectorAll("[data-description]");

      // Map the elements to extract their 'data-label' values
      const descriptions = Array.from(description).map((element) =>
        element.getAttribute("data-description")
      );

      // Return the array of data-label values
      return descriptions;
    } else {
      console.error("Form not found");
      return [];
    }
  }

  // Navigates to the "myProfile" page with a query parameter
  const handleNavigation = (value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("value", value);
    navigate({
      pathname: "/myProfile",
      search: `?${searchParams.toString()}`,
    });
  };

  // Resets the emitter state
  const handleEmitter = () => {
    setEmitterEvent(false);
  };

  // Fetch property listing data based on listing ID and user ID
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (listingId && user?.data?.id) {
          setShowBlurModal(true);
          const formData = new FormData();
          formData.append("user_id", user?.data?.id);
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/myListing/${listingId}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setShowBlurModal(false);
          setApiData(response.data.data);
          setEmitterEvent(true);
        }
      } catch (error) {
        console.error("API Error:", error);
        if (error.response.status === 404) {
          setShowBlurModal(false);
          navigate("/not_found", {
            state: {
              title: "Property Data Not Found",
              status: error.response.status,
            },
          });
        } else {
          setShowBlurModal(false);
          navigate("/not_found", {
            state: {
              title: "Failed to Fetch Data",
              status: error.response.status,
            },
          });
        }
      }
    };
    fetchData();
  }, [listingId, user?.data?.id]);

  // Initialize user profile data into form state when user data is loaded
  useEffect(() => {
    if (user?.data?.role_id == 6 && parseInt(user?.data?.project_count) == 0) {
      navigate("/addProject");
    }
    handleInputChange("basicDetails", "userId", user?.data?.id);
    handleInputChange("basicDetails", "name", user?.data?.name);
    handleInputChange("basicDetails", "phone", user?.data?.mobile);
    handleInputChange("basicDetails", "email", user?.data?.email);
    handleInputChange("basicDetails", "self", user?.data?.role_id);
  }, [user]);

  // Fetch projects based on user input
  useEffect(() => {
    if (projectInput.trim() === "") {
      setProjects([]);
      return;
    }
    setLoadingProjects(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/projects?query=${projectInput}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setProjects(response.data.data);
      })
      .catch((error) => {
        if (error.status === 404) {
          setProjects([]);
        }
      })
      .finally(() => setLoadingProjects(false));
  }, [projectInput]);

  // Fetch projects based on user input
  useEffect(() => {
    checkProfile();
  }, []);

  // Fetch localities when a project is selected
  useEffect(() => {
    setLoadingLocalities(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/search/localities?query=${localityInput}&city_id=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Get token from localStorage
          },
        }
      )
      .then((response) => {
        setLocalities(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching localities:", error))
      .finally(() => setLoadingLocalities(false));
  }, [localityInput]);

  // Fetch and set property images when listingId changes
  useEffect(() => {
    getPropertyImages();
  }, [listingId]);

  // Set form data based on API response when apiData is available and non-empty
  useEffect(() => {
    if (apiData && Object.keys(apiData).length !== 0) {
      setFormData((prev) => ({
        ...prev,
        basicDetails: {
          ...prev.basicDetails,
          id: apiData.id || "",
          profileEdit: apiData.profileEdit || "",
          property_category: apiData.property_category || "",
          property_service: apiData.property_service || "",
        },
        propertyDetails: {
          ...prev.propertyDetails,
          property_type: apiData.property_type || "",
          project_id: apiData.project_id || "",
          sub_locality_id: apiData.sub_locality_id || "",
          locality_id: apiData.locality_id || "",
          furnish_type: apiData.furnish_type || "",
          bhk: apiData.bhk || "",
          possession_status: apiData.possession_status || "",
          available_from: apiData.available_from || "",
          property_age: apiData.property_age || "",
          zone_type: apiData.zone_type || "",
          ownership: apiData.ownership || "",
          location_hub: apiData.location_hub || "",
          other_location_hub: apiData.other_location_hub || "",
          property_name: apiData.property_name || "",
          plot_area: apiData.plot_area || "",
          length: apiData.length || "",
          width: apiData.width || "",
          area_unit: apiData.area_unit || "",
          property_condition: apiData.property_condition || "",
          carpet_area: apiData.carpet_area || "",
          construction_status: apiData.construction_status || "",
          total_floor: apiData.total_floor || "",
          your_floor: Array.isArray(apiData.your_floor)
            ? apiData.your_floor
            : (apiData.your_floor || "")
                .split(",")
                .filter((floor) => floor.trim() !== ""),
          number_of_meeting_rooms_input:
            apiData.number_of_meeting_rooms_input || "",
          number_of_seats_input: apiData.number_of_seats_input || "",
          number_of_cabins_input: apiData.number_of_cabins_input || "",
          buildup_area: (apiData.buildup_area || "").toString(),
          share_agent: apiData.share_agent || "",
          amenities: (apiData.amenities || "")
            .split(",")
            .filter((item) => item.trim() !== "")
            .map((item) => parseInt(item, 10)),
          amenities_furnishes: apiData.amenities_furnishes || "",
          service_lift: apiData.service_lift || "",
          passenger_lifts: apiData.passenger_lifts || "",
          private_parking: apiData.private_parking || "",
          public_parking: apiData.public_parking || "",
          negotiable: apiData.negotiable || "",
          dg_ups_charges: apiData.dg_ups_charges || "",
          tax_govt_charges: apiData.tax_govt_charges || "",
          private_washroom: apiData.private_washroom || "",
          public_washroom: apiData.public_washroom || "",
          electricity_charges: apiData.electricity_charges || "",
          entrance_width: apiData.entrance_width || "",
          ceiling_height: apiData.ceiling_height || "",
          painting_charge: apiData.painting_charge || "",
          painting_charge_amount: apiData.painting_charge_amount || "",
          facing: apiData.facing || "",
          servent_room: (apiData.servent_room || "").toString(),
          parking_charge: apiData.parking_charge || "",
          parking_charge_amount: apiData.parking_charge_amount || "",
          address: apiData.address || "",
          bathroom: (apiData.bathroom || "").toString(),
          boundary_wall: apiData.boundary_wall || "",
          width_facing_road: apiData.width_facing_road || "",
          corner_plot: apiData.corner_plot || "",
          construction_start: apiData.construction_start || "",
          parking_open: apiData.parking_open || "",
          parking_covered: apiData.parking_covered || "",
          water_charges: apiData.water_charges || "",
          reminder_date: apiData.reminder_date || "",
          reminder_time: apiData.reminder_time || "",
          pg_name: apiData.pg_name || "",
          pg_total_beds: apiData.pg_total_beds || "",
          pg_for: (apiData.pg_for || "").split(","),
          pg_suitable_for: (apiData.pg_suitable_for || "").split(","),
          pg_meals_available: apiData.pg_meals_available || "",
          pg_meals_offering: (apiData.pg_meals_offering || "").split(","),
          pg_notice_period: apiData.pg_notice_period || "",
          pg_lock_in: apiData.pg_lock_in || "",
          pg_common_area: (apiData.pg_common_area || "").split(","),
          pg_meals_speciality: apiData.pg_meals_speciality || "",
          meal_charge: apiData.meal_charge || "",
          electricity_charge: apiData.electricity_charge || "",
          non_veg: apiData.non_veg || "",
          opposite_sex: apiData.opposite_sex || "",
          drinking_allowed: apiData.drinking_allowed || "",
          smoking_allowed: apiData.smoking_allowed || "",
          visitor_allowed: apiData.visitor_allowed || "",
          guardian_allowed: apiData.guardian_allowed || "",
          brokerage_amount: apiData.brokerage_amount || "",
          lock_period_amount: apiData.lock_period_amount || "",
          transaction_type: apiData.transaction_type || "",
          maintenance_charge: apiData.maintenance_charge || "",
          brokerage_charge: apiData.brokerage_charge || "",
          brokerage_negotiable: apiData.brokerage_negotiable || "",
          lock_period: apiData.lock_period || "",
          conference_room: apiData.conference_room || "",
          flooring: apiData.flooring || "",
          suitable_for: apiData.suitable_for || "",
          floor_no: apiData.floor_no || "",
          open_sides: apiData.open_sides || "",
          plot_approved: apiData.plot_approved || "",
          plot_authority: apiData.plot_authority || "",
          floor_construction: apiData.floor_construction || "",
          total_stairs: apiData.total_stairs || "",
          possession_date: apiData.possession_date || "",
          balcony: (apiData.balcony || "").toString(),
          property_description: apiData.property_description || "",
        },
        propertyPrice: {
          ...prev.propertyPrice,

          pricing: (apiData.pricing || "").toString(),
          security_deposit_month: apiData.security_deposit_month || "",
          security_deposit_amount: apiData.security_deposit_amount || "",
        },
        roomDetail: apiData.roomDetail || {},
      }));
    }

    setLocalityInput(apiData?.locality || "");
    setProjectInput(apiData?.project_name || "");
  }, [apiData]);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div className="forms" id="myForm">
            <TipModal
              dataFields={dataFields}
              dataDescriptions={dataDescriptions}
              isOpen={isTipModalOpen}
              closeModal={closeTipModal}
            />
            <div className="formHeader" onClick={() => openTipModal()}>
              <span>Add Basic Details</span>
              <span className="infoIcon">ⓘ</span>
            </div>
            <div className="formBodyMain">
              <label
                className="formLabel invisible2"
                data-index="basicDetails"
                data-field="self"
                data-description="self description"
              >
                Describe Yourself As: <span className="required_field">*</span>
              </label>
              <div className={` invisible2 optionList`}>
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={`optionBox  ${
                      formData.basicDetails.self == option ? "active" : ""
                    }`}
                    onClick={() =>
                      handleInputChange("basicDetails", "self", option)
                    }
                  >
                    <span
                      className={`label_icon ${
                        formData.basicDetails.self == option
                          ? "label_icon_active"
                          : ""
                      }`}
                    >
                      {formData.basicDetails.self == option ? "✓" : "X"}
                    </span>
                    <span>{option}</span>
                  </div>
                ))}
              </div>
              {errors.self && (
                <small className="text-danger">{errors.self}</small>
              )}
              <div
                className={`formRow  ${
                  errors.name || errors.city_id ? "mb-4" : "mb-4"
                }`}
              >
                <div className="input-container  w-50">
                  <input
                    type="text"
                    id="nameInput"
                    placeholder=" "
                    className="textField"
                    value={formData.basicDetails.name || ""}
                    onChange={(e) =>
                      handleInputChange("basicDetails", "name", e.target.value)
                    }
                  />
                  <label
                    htmlFor="nameInput"
                    data-index="basicDetails"
                    data-field="name"
                    data-description="name description"
                    className="floating-label"
                  >
                    Name <span className="required_field">*</span>
                  </label>
                  {errors.name && (
                    <small className="text-danger">{errors.name}</small>
                  )}
                </div>

                <div className="w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"basicDetails"}
                    field={"city_id"}
                    data-description="city description"
                    options={cityOptions}
                    required={"1"}
                    placeholder="Select City"
                    onSelect={(value) => console.log("City:", value)}
                  />
                  {errors.city_id && (
                    <small className="text-danger">{errors.city_id}</small>
                  )}
                </div>
              </div>
              <div
                className={`formRow mt-4 ${
                  errors.email || errors.phone ? "mb-5" : "mb-3"
                }`}
              >
                <div className="input-container w-50">
                  <input
                    type="email"
                    id="emailInput"
                    placeholder=" "
                    className="textField"
                    value={formData.basicDetails.email || ""}
                    onChange={(e) =>
                      handleInputChange("basicDetails", "email", e.target.value)
                    }
                  />
                  <label
                    htmlFor="emailInput"
                    data-index="basicDetails"
                    data-field="email"
                    className="floating-label"
                  >
                    Email <span className="required_field">*</span>
                  </label>
                  {errors.email && (
                    <small className="text-danger">{errors.email}</small>
                  )}
                </div>

                <div className="input-container w-50">
                  <input
                    type="tel"
                    id="phoneInput"
                    placeholder=" "
                    className="textField"
                    value={formData.basicDetails.phone || ""}
                    onChange={(e) =>
                      handleInputChange("basicDetails", "phone", e.target.value)
                    }
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                  <label
                    htmlFor="phoneInput"
                    data-index="basicDetails"
                    data-field="phone"
                    className="floating-label"
                  >
                    Phone <span className="required_field">*</span>
                  </label>
                  {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                </div>
              </div>
              <div className="formRow mb-4">
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"basicDetails"}
                    field={"property_category"}
                    options={typeOptions}
                    placeholder="Select Type"
                    required={"1"}
                    onSelect={(value) => console.log("type:", value)}
                  />
                  {errors.property_category && (
                    <small className="text-danger">
                      {errors.property_category}
                    </small>
                  )}
                </div>
                <div className=" w-50">
                  <CustomDropdown
                    formData={formData}
                    handleInputChange={handleInputChange}
                    index={"basicDetails"}
                    field={"property_service"}
                    required={"1"}
                    options={serviceOptions}
                    placeholder="Select Service"
                    onSelect={(value) => console.log("service:", value)}
                  />
                  {errors.property_service && (
                    <small className="text-danger">
                      {errors.property_service}
                    </small>
                  )}
                </div>
              </div>
            </div>
            <div className="formFooter">
              <div className="rectangle_323" onClick={handleNextStep}>
                <button className="ribbonText">Next</button>
              </div>
            </div>
            {showConfirmModal && (
              <ConfirmationModal
                onClose={() => setShowConfirmModal(false)}
                title={msgTitle}
                message={message}
                icon={icon}
                theme={theme}
              />
            )}

            {showBlurModal && <BlurModal />}
          </div>
        );
      default:
        return (
          <PropertyDetailForm
            listingId={listingId}
            activeStep={activeStep}
            errors={errors}
            formData={formData}
            handleInputChange={handleInputChange}
            handleInputDelete={handleInputDelete}
            handleNextStep={handleNextStep}
            handleSubmit={handleSubmit}
            handlePostPropertyClick={handlePostPropertyClick}
            projectInput={projectInput}
            setProjectInput={setProjectInput}
            projects={projects}
            loadingProjects={loadingProjects}
            onSelectProject={setSelectedProject}
            selectedProject={selectedProject}
            localityInput={localityInput}
            setLocalityInput={setLocalityInput}
            localities={localities}
            loadingLocalities={loadingLocalities}
            propertyType={formData.basicDetails.property_category}
            propertyService={formData.basicDetails.property_service}
            selfType={formData.basicDetails.self}
            emitterEvent={emitterEvent}
            handleEmitter={handleEmitter}
            navigate={navigate}
          />
        );
    }
  };

  switch (mainSteps[activeMainStep]) {
    case "details":
      return (
        <div className="exterior postprop pt-2 pb-5">
          <div className="heading pt-5">Post Your Property</div>
          <div className="outerBox">
            <div className="sideBox1">
              <h5 className="steps">
                3 Simple Steps Will Make Your Life Much Easier
                <br />
              </h5>
              <h5 className="steps_1"> Post Your Property And Relax</h5>
              <img
                src={wizard}
                alt="Steps illustration"
                className="stepsImage"
              />
            </div>
            <div className="sideBox2">
              <h5 className="steps pb-4 mob">
                3 Simple Steps Will Make Your Life Much Easier. Post Your
                Property And Relax
              </h5>

              <div className="stepbar">
                {steps.map((step, index) => (
                  <React.Fragment key={index}>
                    <div
                      className="stepbox"
                      onClick={() => handleNextStep(index)}
                    >
                      <p
                        className={`steptxt ${
                          activeStep > index ? "active" : ""
                        }`}
                      >
                        {step}
                      </p>

                      <div
                        className={`stepdot ${
                          activeStep === index
                            ? "active"
                            : activeStep > index
                            ? "visited"
                            : ""
                        }`}
                      >
                        <div
                          className={`stepindot ${
                            activeStep === index
                              ? "active"
                              : activeStep > index
                              ? "visited"
                              : ""
                          }`}
                        >
                          {activeStep > index ? (
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.40039 5.39981L5.13399 8.99981L12.6004 1.7998"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                    {index < steps.length - 1 && (
                      <div
                        className={`stepline  ${
                          activeStep > index ? "active" : ""
                        }`}
                      ></div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {renderStepContent(activeStep)}
            </div>
            {showPopup && (
              <div className="popupbox">
                <div className="popup">
                  <div className="check-div">
                    <img src={check} alt="Popup" className="check" />
                  </div>
                  <div className="" style={{ marginTop: "-15%" }}>
                    <h2 className="congr-text desk">
                      {listingId
                        ? "Thank you for updating your property"
                        : "Congratulations! Your property is under review."}
                    </h2>
                    <h2 className="congr-text mob">
                      {listingId
                        ? "Thank you for updating your property"
                        : "Congratulations! Your property is under review."}
                    </h2>
                    <p className="congr-text-p mt-4">
                      {listingId
                        ? "Meanwhile you can update photos/Videos & other additional details of your property to receive more enquiries"
                        : "Meanwhile you can add photos/Videos & other additional details of your property to receive more enquiries"}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );

    case "images":
      return (
        <div className="exterior1">
          <div className="property-container">
            <div className="property-left-box">
              <div className="property-header">
                <p className="property-title desk">
                  Congratulations! Your Property Is Under Review.
                </p>
                <p className="property-title mob">
                  Congratulations!
                  <br />
                  Your Property Is Under Review.
                </p>
                <p className="property-subtitle">
                  Meanwhile, You Can Add Photos & Other Additional <br />{" "}
                  Details To Receive More Enquiries.
                </p>
              </div>
              <div className="property-options-box">
                <div className="options-cat">
                  <img src={returnHome} alt="Return to Dashboard" />
                  <button
                    className="options-cat-name"
                    onClick={() => navigate("/myProfile?value=myListings")}
                  >
                    Return To Dashboard
                  </button>
                </div>
                <div className="options-cat">
                  <img src={addPhoto} alt="Add Photos/Videos" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(0)}
                  >
                    Add Property Details
                  </button>
                </div>
                <div className="options-cat">
                  <img src={advancedDetails} alt="Advanced Details" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(2)}
                  >
                    Advanced Details
                  </button>
                </div>
                {!listingId && (
                  <div className="options-cat">
                    <img src={verify} alt="Verify Your Property" />
                    <button
                      className="options-cat-name"
                      onClick={() => setActiveMainStep(3)}
                    >
                      Verify Your Property
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="property-right-box">
              <div className="rightBox-title">
                <div>Add Photos/Videos</div>
                <div>
                  <button
                    className="rbButton"
                    onClick={() => setActiveMainStep(2)}
                  >
                    {images.length >= 1 ? "Next" : "Skip"}{" "}
                    <span className={images.length >= 1 ? "arrow1" : ""}>
                      &gt;&gt;
                    </span>
                  </button>
                </div>
              </div>
              <div>
                <div className="rb1">
                  {images.map((image, index) => (
                    <div key={index} style={{ width: "90px" }}>
                      <img
                        src={image.image_url}
                        className="rbox"
                        alt={`Uploaded ${index}`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImage;
                        }}
                      />
                      <button
                        className="delete-button btn"
                        onClick={() => handleDelete(index, image.id)}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2785_1188)">
                            <path
                              d="M7.64199 12.3587L12.3587 7.64199M12.3587 12.3587L7.64199 7.64199M10.0003 18.3337C14.5837 18.3337 18.3337 14.5837 18.3337 10.0003C18.3337 5.41699 14.5837 1.66699 10.0003 1.66699C5.41699 1.66699 1.66699 5.41699 1.66699 10.0003C1.66699 14.5837 5.41699 18.3337 10.0003 18.3337Z"
                              stroke="#B7B7B7"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2785_1188">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                      <div className="image-dropdown">
                        {image.image_url.toLowerCase().endsWith(".pdf") ? (
                          // Dropdown for PDFs
                          <select
                            className="image-dropdown1"
                            onChange={(e) =>
                              handleCategory(image.id, e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            <option value="brochure">Brochure</option>
                          </select>
                        ) : (
                          // Dropdown for images
                          <select
                            className="image-dropdown2"
                            onChange={(e) =>
                              handleCategory(image.id, e.target.value)
                            }
                          >
                            <option value="" selected={image.category === ""}>
                              Select
                            </option>
                            <option
                              value="cover"
                              selected={image.category === "cover"}
                            >
                              Cover
                            </option>
                            <option
                              value="living"
                              selected={image.category === "living"}
                            >
                              Living Room
                            </option>
                            <option
                              value="kitchen"
                              selected={image.category === "kitchen"}
                            >
                              Kitchen
                            </option>
                            <option
                              value="bathroom"
                              selected={image.category === "bathroom"}
                            >
                              Bathroom
                            </option>
                            <option
                              value="dining room"
                              selected={image.category === "dining room"}
                            >
                              Dining Room
                            </option>
                            <option
                              value="laundary room"
                              selected={image.category === "laundary room"}
                            >
                              Laundry Room
                            </option>
                            <option
                              value="bedroom"
                              selected={image.category === "bedroom"}
                            >
                              Bedroom
                            </option>
                            <option
                              value="balcony"
                              selected={image.category === "balcony"}
                            >
                              Balcony
                            </option>
                            <option
                              value="front view"
                              selected={image.category === "front view"}
                            >
                              Front View
                            </option>
                            <option
                              value="garden"
                              selected={image.category === "garden"}
                            >
                              Garden
                            </option>
                            <option
                              value="terrace"
                              selected={image.category === "terrace"}
                            >
                              Terrace
                            </option>
                            <option
                              value="rooftop"
                              selected={image.category === "rooftop"}
                            >
                              Rooftop
                            </option>
                            <option
                              value="parking area"
                              selected={image.category === "parking area"}
                            >
                              Parking Area
                            </option>
                            <option
                              value="swimming pool"
                              selected={image.category === "swimming pool"}
                            >
                              Swimming Pool
                            </option>
                            <option
                              value="gym"
                              selected={image.category === "gym"}
                            >
                              Gym
                            </option>
                            <option
                              value="play area"
                              selected={image.category === "play area"}
                            >
                              Play Area
                            </option>
                            <option
                              value="lift / staircase"
                              selected={image.category === "lift / staircase"}
                            >
                              Lift / Staircase
                            </option>
                            <option
                              value="office space"
                              selected={image.category === "office space"}
                            >
                              Office Space
                            </option>
                            <option
                              value="meeting / conference room"
                              selected={
                                image.category === "meeting / conference room"
                              }
                            >
                              Meeting / Conference Room
                            </option>
                            <option
                              value="retail / shop area"
                              selected={image.category === "retail / shop area"}
                            >
                              Retail / Shop Area
                            </option>
                            <option
                              value="warehouse"
                              selected={image.category === "warehouse"}
                            >
                              Warehouse
                            </option>
                            <option
                              value="reception"
                              selected={image.category === "reception"}
                            >
                              Reception
                            </option>
                            <option
                              value="prayer room"
                              selected={image.category === "prayer room"}
                            >
                              Prayer Room
                            </option>
                          </select>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  className="insbox"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <p>Drag & Drop here</p>
                  <p>or</p>

                  <label for="file-upload" className="image-label">
                    Browse
                  </label>
                  <input
                    type="file"
                    id="file-upload"
                    className="instext"
                    multiple
                    onChange={(e) => handleFileChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );

    case "advanced":
      return (
        <div className="exterior1">
          <div className="property-container">
            <div className="property-left-box">
              <div className="property-header">
                <p className="property-title">
                  Congratulations! Your Property Is Under Review.
                </p>
                <p className="property-subtitle">
                  Meanwhile, You Can Add Photos & Other Additional <br />{" "}
                  Details To Receive More Enquiries.
                </p>
              </div>
              <div className="property-options-box">
                <div className="options-cat">
                  <img src={returnHome} alt="Return to Dashboard" />
                  <button
                    className="options-cat-name"
                    onClick={() => navigate("/myProfile?value=myListings")}
                  >
                    Return To Dashboard
                  </button>
                </div>
                <div className="options-cat">
                  <img src={addPhoto} alt="Add Photos/Videos" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(1)}
                  >
                    Add Photos/Videos
                  </button>
                </div>
                <div className="options-cat">
                  <img src={advancedDetails} alt="Advanced Details" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(2)}
                  >
                    Advanced Details
                  </button>
                </div>
                {!listingId && (
                  <div className="options-cat">
                    <img src={verify} alt="Verify Your Property" />
                    <button
                      className="options-cat-name"
                      onClick={() => setActiveMainStep(3)}
                    >
                      Verify Your Property
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="property-right-box">
              <div className="rightBox-title">
                <div>Add Advanced Details</div>
                <div>
                  <button
                    className="rbButton"
                    onClick={() => setActiveMainStep(3)}
                  >
                    {" "}
                    Skip&gt;&gt;
                  </button>{" "}
                </div>
              </div>

              <AdvanceForm
                errors={errors}
                handleInputChange={handleInputChange}
                handleAdvanceSubmit={handleAdvanceSubmit}
                formData={formData}
                propertyType={formData.basicDetails.property_category}
                propertyService={formData.basicDetails.property_service}
                selfType={formData.basicDetails.self}
                propertySubType={formData.propertyDetails.property_type}
              />
            </div>
          </div>
        </div>
      );

    case "verify":
      return (
        <div className="exterior1">
          <div className="property-container1 mt-5 mb-5">
            <div className="property-left-box">
              <div className="property-header">
                <p className="property-title">
                  Congratulations! Your Property Is Under Review.
                </p>
                <p className="property-subtitle">
                  Meanwhile, You Can Add Photos & Other Additional <br />{" "}
                  Details To Receive More Enquiries.
                </p>
              </div>
              <div className="property-options-box">
                <div className="options-cat">
                  <img src={returnHome} alt="Return to Dashboard" />
                  <button
                    className="options-cat-name"
                    onClick={() => navigate("/myProfile?value=myListings")}
                  >
                    Return To Dashboard
                  </button>
                </div>
                <div className="options-cat">
                  <img src={addPhoto} alt="Add Photos/Videos" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(1)}
                  >
                    Add Photos/Videos
                  </button>
                </div>
                <div className="options-cat">
                  <img src={advancedDetails} alt="Advanced Details" />
                  <button
                    className="options-cat-name"
                    onClick={() => setActiveMainStep(2)}
                  >
                    Advanced Details
                  </button>
                </div>
                {!listingId && (
                  <div className="options-cat">
                    <img src={verify} alt="Verify Your Property" />
                    <button
                      className="options-cat-name"
                      onClick={() => setActiveMainStep(3)}
                    >
                      Verify Your Property
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="property-right-box1">
              <div className="rightBox-title">
                <p className="verify-title">Verify Your Property</p>
                <div className="imgBox" onClick={openVisibleModal}>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.375 3.875V4.6675C11.7487 4.88375 12 5.2875 12 5.75C12 6.44 11.44 7 10.75 7C10.06 7 9.5 6.44 9.5 5.75C9.5 5.2875 9.75125 4.88375 10.125 4.6675V4.1875C10.125 3.67 9.705 3.25 9.1875 3.25C8.67 3.25 8.25 3.67 8.25 4.1875V9.5V9.50812C8.24563 10.8844 7.12687 12 5.75 12C4.37 12 3.25 10.88 3.25 9.5V9.39313C2.52188 9.13563 2 8.44063 2 7.625C2 6.59 2.84 5.75 3.875 5.75C4.91 5.75 5.75 6.59 5.75 7.625C5.75 8.44063 5.22813 9.13563 4.5 9.39313V9.50375C4.5 9.5675 4.505 9.63125 4.515 9.69438C4.53063 9.79437 4.55875 9.89313 4.59812 9.98625C4.65875 10.13 4.74687 10.2619 4.85562 10.3731C4.96 10.48 5.08313 10.5681 5.21875 10.6313C5.335 10.6863 5.45937 10.7231 5.58687 10.7394C5.72375 10.7575 5.86312 10.7525 5.99812 10.7256C6.11438 10.7019 6.2275 10.6619 6.3325 10.6063C6.45625 10.5406 6.56938 10.4544 6.665 10.3513C6.75938 10.25 6.83625 10.1337 6.8925 10.0075C6.93625 9.90875 6.9675 9.80438 6.98438 9.69813C6.995 9.6325 7 9.56625 7 9.5V4.1875C7 2.98 7.98 2 9.1875 2C10.2887 2 11.2006 2.81562 11.3525 3.875H11.375ZM3.875 7C3.53 7 3.25 7.28 3.25 7.625C3.25 7.97 3.53 8.25 3.875 8.25C4.22 8.25 4.5 7.97 4.5 7.625C4.5 7.28 4.22 7 3.875 7Z"
                      fill="#1B4E9B"
                    />
                  </svg>
                  <p>Procedure</p>
                </div>
              </div>
              <div className="formBody2">
                <p className="verify-description">
                  We will visit the property to verify it. Schedule the date and
                  we’ll get back to you first on call then on location. Please
                  be on location at the scheduled date and time.
                </p>
                <div className="d-flex dttim justify-content-between">
                  <div className="d-flex">
                    <div className=" w-50">
                      <input
                        type="date"
                        id="reminder_date"
                        placeholder="Date"
                        value={formData.propertyDetails.reminder_date || ""}
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "reminder_date",
                            e.target.value
                          )
                        }
                        className="verify-input"
                      />
                      {reminderErrors.reminder_date && (
                        <small className="text-danger">
                          {reminderErrors.reminder_date}
                        </small>
                      )}
                    </div>
                    <div className=" w-50">
                      <input
                        type="time"
                        id="reminder_time"
                        placeholder=" "
                        value={formData.propertyDetails.reminder_time || ""}
                        onChange={(e) =>
                          handleInputChange(
                            "propertyDetails",
                            "reminder_time",
                            e.target.value
                          )
                        }
                        className="verify-input"
                      />

                      {reminderErrors.reminder_time && (
                        <small className="text-danger">
                          {reminderErrors.reminder_time}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      className="reminder-button"
                      onClick={(e) => handleSetReminderSubmit(e)}
                    >
                      Set Reminder
                    </button>
                  </div>
                </div>
                <div className="finalribbon">
                  <button
                    className="finalskip"
                    onClick={() => handleNavigation("myListings")}
                  >
                    Skip &gt;&gt;
                  </button>
                </div>
              </div>
            </div>
          </div>
          {isModalOpen && <Procedures closeModal={closeVisibleModal} />}

          {showConfirmModal && (
            <ConfirmationModal
              onClose={() => setShowConfirmModal(false)}
              title={msgTitle}
              message={message}
              icon={icon}
              theme={theme}
            />
          )}
        </div>
      );
  }
}
